import { render, staticRenderFns } from "./modalFreepick.vue?vue&type=template&id=65580f84&scoped=true"
import script from "./modalFreepick.vue?vue&type=script&lang=js"
export * from "./modalFreepick.vue?vue&type=script&lang=js"
import style0 from "./modalFreepick.vue?vue&type=style&index=0&id=65580f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65580f84",
  null
  
)

export default component.exports